import { render, staticRenderFns } from "./pelunasanmemoview.vue?vue&type=template&id=5b05f951&"
import script from "./pelunasanmemoview.vue?vue&type=script&lang=js&"
export * from "./pelunasanmemoview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports